<template>
    <div class="VotingResult">
        <div v-if="InfoRange.VotingUser[0].Id_UserType">
          <va-notification color="warning" class="refNoData">Su tipo de usuario no permite realizar una votacion en el sistema, Gracias.</va-notification>
        </div>
        <div v-else>
          <va-notification color="info" class="refNoData">Su voto fue procesado exitosamente el {{valdate(InfoRange.VotingUser[0].Date_Voting)}}, Gracias.</va-notification>
        </div>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'VotingResult',
  props: {
    InfoRange: Object,
  },
  methods: {
    valdate (infoDat) {
      return IberoHelpers.dataObjDate(infoDat)
    },
  },
}
</script>

<style scoped>
.refNoData {
  padding: 10px;
  padding-left: 20px;
}
</style>
